import React, { useState, useRef } from 'react';
import ListOfSectionMenu from './ListOfSectionMenu';
import { toggleModal } from '../../reducers/modalReducer';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import KeyFeatureSeeMoreModal from '../modals/KeyFeatureSeeMoreModal';
import ModalWrapper from '../common/Modal/ModalWrapper';

const ModuleCardMenus = ({ module, onNavigateSection, menus, reportMenu }) => {
    const [selectedSeeMore, setSelectedSeeMore] = useState({});
    const [activeDynamicMenu, setActiveDynamicMenu] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const hoverTimeoutRef = useRef(null);
    const dispatch = useDispatch();
    let sections = module?.['sections'] || module?.['module']?.['sections'] || [];

    const handleDynamicMenuClick = (menu) => {
        if (!menu || menu.isActive === false) return;

        if (menu.actionType === 'navigate') {
            if (menu.navigateUrl) {
                window.open(menu.navigateUrl, '_blank', 'noopener,noreferrer');
            }
            return;
        }

        if (menu.actionType === 'modal') {
            setActiveDynamicMenu(menu);
            dispatch(toggleModal({ open: 'dynamicModuleMenuModal' }));
        }
    };

    const dynamicMenus = Array.isArray(module?.menusConfig) ? module.menusConfig.filter(m => m && m.isActive !== false) : [];

    const handleMouseEnter = () => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
        setIsOpen(true);
    };

    const handleMouseLeave = () => {
        // Small delay so slight mouse gaps don't instantly close the menu
        hoverTimeoutRef.current = setTimeout(() => {
            setIsOpen(false);
        }, 150);
    };

    return (
        <>
            <div
                className="ds-module-menu"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <div className="ds-module-card__menu">•••</div>
                <div
                    className="ds-module-menu__dropdown"
                    style={{ display: isOpen ? 'block' : 'none' }}
                >
                    <div className="ds-module-menu__section ds-submenu">
                        {
                            sections.length > 0 && (menus?.includes('listOfSections') || module?.['menus']?.includes('listOfSections')) && <ListOfSectionMenu module={module} sections={sections} onNavigateSection={onNavigateSection} />
                        }
                        {dynamicMenus.map((menu) => (
                            <button
                                key={menu.key || menu.label}
                                type="button"
                                onClick={() => handleDynamicMenuClick(menu)}
                                className="ds-module-menu__item df aic"
                            >
                                {menu.iconURL && (
                                    <img
                                        style={{ width: '16px', height: '16px', marginRight: '8px' }}
                                        src={menu.iconURL}
                                        alt={menu.label || 'menu-icon'}
                                    />
                                )}
                                {menu.label || 'Menu'}
                            </button>
                        ))}

                        {reportMenu && reportMenu.length > 0 && <>
                            <div className="ds-module-menu__divider" />
                            {
                                reportMenu.map((menu) => (
                                    <button
                                        key={menu.key || menu.label}
                                        type="button"
                                        onClick={() => handleDynamicMenuClick(menu)}
                                        className="ds-module-menu__item df aic"
                                    >
                                        {menu.key === 'report' && (
                                            <img style={{ width: '16px', height: '16px', marginRight: '8px' }} src={require('../../../images/dashboard/icons/R.png')} alt="report" />
                                        )}
                                        {menu.key === 'workflowReport' && (
                                            <img style={{ width: '16px', height: '16px', marginRight: '8px' }} src={require('../../../images/dashboard/icons/WF.png')} alt="workflow-report" />
                                        )}
                                        {menu.label || 'Menu'}
                                    </button>
                                ))
                            }

                        </>}
                    </div>
                </div>
            </div>
            {Object.keys(selectedSeeMore).length ? <KeyFeatureSeeMoreModal selectedSeeMore={selectedSeeMore} /> : null}

            {activeDynamicMenu && activeDynamicMenu.actionType === 'modal' && (
                <ModalWrapper
                    modalType="dynamicModuleMenuModal"
                    modalCardClasses="maw900px"
                    onCloseHandler={() => setActiveDynamicMenu(null)}
                    customStyle={{ padding: '2rem' }}
                >
                    <div className="poppins-font-style w100 df fdc">
                        {activeDynamicMenu.modalTitle && (
                            <h2 className="fs1-5rem fw600 c15 mb1rem tac">
                                {activeDynamicMenu.modalTitle}
                            </h2>
                        )}
                        {activeDynamicMenu.modalImageURL && (
                            <img
                                src={activeDynamicMenu.modalImageURL}
                                alt={activeDynamicMenu.modalTitle || 'menu-modal'}
                                style={{ width: '100%', borderRadius: '12px', objectFit: 'contain' }}
                            />
                        )}
                    </div>
                </ModalWrapper>
            )}
        </>
    )
};

export default ModuleCardMenus;
